export const SET_SHOP_RATINGS = 'SET_SHOP_RATINGS';
export const SET_SHOP_RATINGS_LOADING = 'SET_SHOP_RATINGS_LOADING';
export const SET_SHOP_RATINGS_ERROR = 'SET_SHOP_RATINGS_ERROR';
